import { createFileRoute } from "@tanstack/react-router";
import { LiveAdminPage } from "@/components/shared/LiveAdminPage";
export const Route = createFileRoute("/admin.technicians")({ component: Page });
function Page() {
  return (
    <LiveAdminPage
      title="Technicians"
      description="Field service technicians."
      table="technicians"
      columns={[
        { key: "user_id", label: "User" },
        { key: "service_zone", label: "Zone" },
        { key: "status", label: "Status" },
        { key: "rating", label: "Rating" },
      ]}
    />
  );
}
